import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { applyStoredFontScale, applyStoredTheme } from './views/v2/displayPrefs';
import './styles/globals.css';

// The theme and text size a viewer chose, applied before the first paint so it does not
// flash the default. The fonts and `data-app` are in index.html.
applyStoredTheme();
applyStoredFontScale();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
